import HelpIcon from './help-icon';

interface InputFieldLabelProps {
  label: string;
  tooltip?: string;
}
function InputFieldLabel({ label, tooltip }: InputFieldLabelProps) {
  return (
    <div className="flex items-center gap-2">
      <label className="font-prompt-safe-com-semantic-label text-prompt-safecomvulcan">
        {label}
      </label>
      {tooltip && tooltip !== '' && <HelpIcon content={tooltip} />}
    </div>
  );
}

export default InputFieldLabel;
